import { render, staticRenderFns } from "./dap-submitted-projects.page.vue?vue&type=template&id=453ee806&scoped=true"
import script from "./dap-submitted-projects.page.vue?vue&type=script&lang=ts"
export * from "./dap-submitted-projects.page.vue?vue&type=script&lang=ts"
import style0 from "./dap-submitted-projects.page.vue?vue&type=style&index=0&id=453ee806&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453ee806",
  null
  
)

export default component.exports